import { render } from "./PracticeTestStudent.vue?vue&type=template&id=defcc4ba&scoped=true"
import script from "./PracticeTestStudent.vue?vue&type=script&lang=js"
export * from "./PracticeTestStudent.vue?vue&type=script&lang=js"

import "./PracticeTestStudent.vue?vue&type=style&index=0&id=defcc4ba&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-defcc4ba"]])

export default __exports__